import classNames from 'classnames'
import * as React from 'react'
import {render} from 'storyblok-rich-text-react-renderer'

import {isEmptyRichtext, makeEditable} from '@/common/utils'
import Content from '@/components/Content'
import {Grid} from '@/components/Grid'
import Heading from '@/components/Heading'
import Image from '@/components/Image'

const CardsBanner = ({backgroundColors, id, headingTag, heading, content, cards, _editable}) => {
  const HeadingTag = headingTag || 'p'

  return (
    <section
      id={id || undefined}
      {...makeEditable(_editable)}
      className={classNames('py-17 lg:py-34', backgroundColors.current)}
    >
      <Grid>
        {(!isEmptyRichtext(heading) || !isEmptyRichtext(heading)) && (
          <div className='col-span-full flex flex-col items-center text-center md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3'>
            {!isEmptyRichtext(heading) && (
              <HeadingTag>
                <Heading heading={heading} />
              </HeadingTag>
            )}
            {!isEmptyRichtext(heading) && <Content content={content} />}
          </div>
        )}

        <div className='col-span-full mt-12'>
          <div className='flex flex-wrap justify-center gap-8'>
            {cards.map(({_uid, heading, content, icon, image}) => {
              return (
                <div
                  key={_uid}
                  className='relative flex h-full w-fit flex-col items-center gap-y-20 p-6'
                >
                  {icon.filename ? (
                    <div className='flex h-26 w-26 items-center justify-center rounded-2xl bg-violet-400 p-6'>
                      <div className='h-14 w-14'>
                        <Image
                          {...icon}
                          ratio='1:1'
                          sizes={{md: 30, lg: 50}}
                          className='h-full w-full object-contain'
                        />
                      </div>
                    </div>
                  ) : (
                    <div className='h-[304px] w-[242px]'>
                      <Image
                        {...image}
                        ratio='4:5'
                        sizes={{md: 30, lg: 50}}
                        className='h-full w-full rounded-2xl object-contain'
                      />
                    </div>
                  )}

                  <div className='flex flex-col items-center justify-center rounded-b-2xl text-center'>
                    {!isEmptyRichtext(heading) && (
                      <div className='heading-xs-millik'>{render(heading)}</div>
                    )}
                    {!isEmptyRichtext(content) && (
                      <div className='body-s-medium w-54'>{render(content)}</div>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </Grid>
    </section>
  )
}

export default CardsBanner
